import { Typography } from '@axafr-btc-ds/typography';
import { ColorHex } from '@axafr-btc-ds/colors';
import classnames from 'classnames';
import styles from './FormContainer.module.css';
import { FormContainerProps } from './FormContainer.interface';

export const FormContainer = ({
    className,
    title,
    titleProps,
    subtitle,
    subtitleProps,
    inputContainerClassName,
    children,
}: FormContainerProps) => {
    return (
        <div className={ classnames(styles.container, className) }>
            <Typography
                color={ ColorHex.axablue }
                variant="title1"
                component="h1"
                style={ { whiteSpace: 'pre-line' } }
                { ...titleProps }
                className={ classnames(styles.title, titleProps?.className) }
            >
                { title }
            </Typography>
            { subtitle &&
                <Typography
                    variant="body2"
                    component='div'
                    { ...subtitleProps }
                    className={ classnames(styles.subtitle, subtitleProps?.className) }
                >
                    { subtitle }
                </Typography>
            }
            <div className={ classnames(styles.inputContainer, inputContainerClassName) }>
                { children }
            </div>
        </div>
    );
};
